import { type ContactUsPlaceholderContent, type ContentComponent } from '../../../../types/construct.types';
import { ContactUsForm } from '../../../support-components/contact-us-form/contact-us-form.component';

export const ContactUsPlaceholder: ContentComponent<ContactUsPlaceholderContent> = () => <ContactUsForm />;
